import { ACTIVATION_LOADING_KEY } from "react/components/NewVersionOptIn/OptInLandingPage/hooks/useSessionStorage";
import { create } from "zustand";

import { browserSessionStorage } from "@/react/lib/browserStorage";

// Preview activation redirects via window.location.href, which reloads the app.
// Zustand state is lost on that navigation, so we mirror isVisible to session
// storage and sync-read it when the store initializes on /ai.
interface ActivationLoadingScreenStore {
  clear: () => void;
  isVisible: boolean;
  start: () => void;
}

const readIsVisibleFromStorage = (): boolean => {
  try {
    const raw = browserSessionStorage.getItem(ACTIVATION_LOADING_KEY);
    if (!raw) {
      return false;
    }

    return JSON.parse(raw) === true;
  } catch {
    return false;
  }
};

const writeIsVisibleToStorage = (isVisible: boolean) => {
  try {
    if (isVisible) {
      browserSessionStorage.setItem(
        ACTIVATION_LOADING_KEY,
        JSON.stringify(true),
      );
      return;
    }

    browserSessionStorage.removeItem(ACTIVATION_LOADING_KEY);
  } catch {
    console.warn(
      `Unable to access session storage for key "${ACTIVATION_LOADING_KEY}".`,
    );
  }
};

export const useActivationLoadingScreenStore =
  create<ActivationLoadingScreenStore>(set => ({
    isVisible: readIsVisibleFromStorage(),
    start: () => {
      writeIsVisibleToStorage(true);
      set({ isVisible: true });
    },
    clear: () => {
      writeIsVisibleToStorage(false);
      set({ isVisible: false });
    },
  }));
